// Enum for event type of grid option
// means if user click on particular more option item in grid then what type of event occurs like view/edit etc
export enum GridMoreOptionsEnum {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  DUMMY = 'DUMMY',
  DOWNLOAD = 'DOWNLOAD',
}
